import {
    mdiAccountSchoolOutline,
    mdiCalendarWeekOutline,
    mdiClockOutline,
    mdiHomeOutline,
    mdiSendOutline,
} from '@mdi/js';
import type { RouteRecordRaw } from 'vue-router';

const colors = {
    availability: 'teal',
    students: 'cyan',
    surveys: 'blue',
    studoku: 'indigo',
    settings: 'blue-grey',
};

export const appRoutes: Readonly<RouteRecordRaw[]> = [
    {
        path: '',
        name: 'app-index',
        redirect: { path: '/app/home' },
    },
    {
        path: 'home',
        name: 'home',
        component: () => import('@/app/views/HomeView.vue'),
        meta: {
            icon: mdiHomeOutline,
            drawerTitle: 'Home',
        },
    },
    {
        path: 'availability',
        name: 'availability',
        component: () => import('@/app/views/AvailabilityView.vue'),
        meta: {
            theme: colors.availability,
            icon: mdiClockOutline,
            drawerTitle: 'Availability',
            homeTitle: 'Configure Availability',
            description: 'Set your available teaching hours and preferences.',
        },
    },
    {
        path: 'students',
        name: 'students',
        component: () => import('@/app/views/StudentsView.vue'),
        meta: {
            theme: colors.students,
            icon: mdiAccountSchoolOutline,
            drawerTitle: 'Students',
            homeTitle: 'Add Students',
            description: 'Add student contact information to your roster.',
        },
    },
    {
        path: 'surveys',
        name: 'surveys',
        component: () => import('@/app/views/SurveysView.vue'),
        meta: {
            theme: colors.surveys,
            icon: mdiSendOutline,
            drawerTitle: 'Surveys',
            homeTitle: 'Send Surveys',
            description:
                'Send surveys to collect student scheduling preferences.',
        },
    },
    {
        path: 'schedules',
        name: 'schedules',
        component: () => import('@/app/views/SchedulesView.vue'),
        meta: {
            theme: colors.studoku,
            icon: mdiCalendarWeekOutline,
            drawerTitle: 'Schedules',
            homeTitle: 'Create Schedules',
            description: 'Automatically create new studoku schedules.',
        },
    },
    {
        path: 'billing',
        name: 'billing',
        component: () => import('@/app/views/BillingView.vue'),
    },
    {
        path: 'settings',
        name: 'settings',
        component: () => import('@/app/views/SettingsView.vue'),
        meta: {
            theme: colors.settings,
        },
    },
    {
        path: ':pathMatch(.*)*',
        name: 'teacher-app-not-found',
        component: () => import('@/app/views/NotFoundView.vue'),
    },
];
